<script setup lang="ts">
interface Props {
  iconClass?: string
  placeholder?: string
}

const props = withDefaults(defineProps<Props>(), {
  iconClass: 'icons-icon-gray-search',
  placeholder: undefined
})

const q = ref('')

const router = useRouter()
const localePath = useLocalePath()

function onClick() {
  const searchQuery = q.value
  q.value = ''
  router.push(localePath({ path: '/inquire', query: { q: searchQuery } }))
}
</script>

<template>
  <div>
    <input
      v-model.trim="q"
      class="form-control"
      :placeholder="props.placeholder || $t('search_default_placeholder')"
      @keypress.enter="onClick"
    />
    <div class="cursor-pointer" :class="props.iconClass" @click="onClick">
      <img alt="" src="~/assets/app/images/icon-search.png" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
